/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';

import {
  initState,
  selectItemById,
  selectItemsIds,
  sendRequest,
  selectRequestState,
  changeStaticQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import ContestListItem from './ContestListItem';

const userRatingStatusesListRN = 'contests.lists.contestsList';

class ContestList extends Component {
  constructor(props) {
    super(props);
    this.props.initState();
    this.props.changeStaticQueryParams(props.staticQueryParams);
    this.props.sendRequest();
  }
  render() {
    if (this.props.requestState.inProgress) {
      return <MediumPreLoader />;
    } else if (this.props.itemsIds.length === 0) {
      return (
        <div className="alert alert-default text-center">
          <p>По вашему запросу ничего не найдено :-(</p>
        </div>
      );
    }
    return (
      <div>
        {this.props.itemsIds.map(itemId => (
          <ContestListItem
            key={`ContestListItem${itemId}`}
            item={this.props.selectItemById(itemId)}
          />
        ))}
      </div>
    );
  }
}

ContestList.propTypes = {
  // IN
  staticQueryParams: PropTypes.shape({}).isRequired,

  // CONNECT STATE
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,

  // CONNECT DISPATCH
  initState: PropTypes.func.isRequired,
  changeStaticQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  selectItemById: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, userRatingStatusesListRN),
  itemsIds: selectItemsIds(state, userRatingStatusesListRN),
  selectItemById: id => selectItemById(state, userRatingStatusesListRN, id)
});

const mapDispatchToProps = dispatch => ({
  initState: () => dispatch(initState(userRatingStatusesListRN)),
  changeStaticQueryParams: value =>
    dispatch(changeStaticQueryParams(userRatingStatusesListRN, value)),
  sendRequest: () => dispatch(sendRequest(userRatingStatusesListRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContestList);



// WEBPACK FOOTER //
// ./src/components/Contest/layouts/ContestList/ContestList.js